import FormattedMessage from 'I18n/components/FormattedMessage';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Link } from 'foundations-components/transitional/components/Link';
import { MEETINGS_LINK_TYPES as LINK_TYPES } from 'hubspot-prosemirror/draft-transplant/utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MeetingsLinkSelectionRadio = ({
  linkType,
  selectedLink,
  radioName,
  handleRadioChange,
  allowSenderMeetingLink
}) => {
  const isSelected = linkType === LINK_TYPES.CUSTOM;
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [allowSenderMeetingLink && /*#__PURE__*/_jsx(RadioInput, {
      name: radioName,
      checked: isSelected,
      onChange: () => handleRadioChange(LINK_TYPES.CUSTOM),
      padding: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.custommeetingslink"
      })
    }), /*#__PURE__*/_jsx(Link, {
      href: selectedLink,
      external: true,
      disabled: !isSelected,
      marginInlineStart: "auto",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.previewBookingPage"
      })
    })]
  });
};
export default MeetingsLinkSelectionRadio;